export enum Action {
  Create = 'CREATE',
  Update = 'UPDATE',
  Delete = 'DELETE',
  Shift = 'SHIFT',
  Duplicate = 'DUPLICATE',
  Refresh = 'REFRESH',
  Bulk = 'BULK',
  Patch = 'PATCH',
}

export enum ObjectType {
  Task = 'TASK',
  User = 'USER',
  Users = 'USERS',
  Team = 'TEAM',
  Field = 'FIELD',
  Comment = 'COMMENT',
  ConversationComment = 'CONVERSATION_COMMENT',
  Project = 'PROJECT',
  ProjectConversation = 'PROJECT_CONVERSATIONS',
  ProjectPhase = 'PROJECT_PHASE',
  Notification = 'NOTIFICATION',
  Attachment = 'ATTACHMENT',
  AttachmentAssociation = 'ATTACHMENT_ASSOCIATION',
  Document = 'DOCUMENT',
  DocumentComment = 'DOCUMENT_COMMENT',
  Approvals = 'APPROVALS',
  Space = 'SPACE',
  ProjectMembers = 'PROJECT_MEMBERS',
  ProjectMembersV2 = 'PROJECT_MEMBERS_V2', // * Used in RM
  TimesheetComment = 'TIMESHEET_COMMENT',
  ResourceAllocation = 'RESOURCE_ALLOCATION',
  AccountMembers = 'ACCOUNT_MEMBERS',
  ProjectSpace = 'PROJECT_SPACE',
  SpaceTab = 'SPACE_TAB',
  AsyncProcessor = 'ASYNC_PROCESSOR',
  ConversationReadReceipt = 'CONVERSATION_COMMENT_READ_RECEIPT',
  Sprint = 'SPRINT',
  ResourceRequest = 'RESOURCE_REQUEST',
  Invoice = 'INVOICE',
  InvoiceConversation = 'INVOICE_CONVERSATION',
  ProjectFinanicalField = 'FINANCIAL',
  Form = 'FORM',
  Company = 'COMPANY',
  TimeEntry = 'TIME_ENTRY',
  Epic = 'EPIC',
  Backlog = 'BACKLOG',
  TimeEntryBulkAction = 'TIME_ENTRY_BULK_ACTION',
  Expense = 'EXPENSE',
  SheetTab = 'SHEET_TAB',
  ExpenseReport = 'EXPENSE_REPORT',
  RevenueEntry = 'REVENUE_ENTRY',
  RevenueEntryBulkAction = 'REVENUE_ENTRY_BULK_ACTION',
  FinancialsBudgetMembers = 'FINANCIALS_BUDGET_MEMBER',
  ProjectFinancialBudget = 'PROJECT_FINANCIALS_BUDGET',
  Metering = 'METERING',
}

export enum ObjectEventType {
  Individual = 'INDIVIDUAL',
  Batch = 'BATCH',
}

export interface AccountSocketData<T> {
  accountId: number;
  valueAt: number;
  action: Action;
  objectType: ObjectType;
  objectEventType: ObjectEventType;
  hopId: string;
  requestId: string;
  data: T;
}

export interface SocketData<T> extends AccountSocketData<T> {
  projectId: number;
  actionBy: number;
}

export interface TeamSocketData<T> extends AccountSocketData<T> {
  projectId?: number;
}

export type EventType = [Action, ObjectType];
export const EventType = (action: Action, type: ObjectType): EventType => [
  action,
  type,
];

export interface EmailUser {
  userId?: number;
  emailId?: string;
}
